var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 26,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 12,
  stroke: "#505153",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#505153",
  d: "m15.32 13.05 3.516 3.55a1.044 1.044 0 0 1 0 1.548l-.773.773a1.044 1.044 0 0 1-1.547 0L13 15.406 9.45 18.92a1.044 1.044 0 0 1-1.548 0l-.773-.773a1.044 1.044 0 0 1 0-1.547l3.516-3.551-3.516-3.516a1.044 1.044 0 0 1 0-1.546l.773-.774a1.044 1.044 0 0 1 1.547 0L13 10.73l3.516-3.516a1.044 1.044 0 0 1 1.547 0l.773.774a1.044 1.044 0 0 1 0 1.546z"
})));
export default SvgClose;